export default __webpack_public_path__ + "static/media/ring-placeholder-info.85aa792e.png";